import * as UpChunk from '@mux/upchunk';

export const CHUNK_SIZE_KB = 5120;

export function cancelledError() {
  const error = new Error('Upload cancelled');
  error.cancelled = true;
  return error;
}

// Resumable, chunked upload straight to the Mux direct-upload URL (same settings as VideoPlayer.gg).
export function startMuxUpload({ endpoint, file, onProgress, onPaused, onResumed }) {
  let upload;
  let rejectDone;
  const done = new Promise((resolve, reject) => {
    rejectDone = reject;
    upload = UpChunk.createUpload({ endpoint, file, chunkSize: CHUNK_SIZE_KB });
    upload.on('progress', event => onProgress && onProgress(Math.round(Number(event && event.detail) || 0)));
    upload.on('offline', () => onPaused && onPaused());
    upload.on('online', () => onResumed && onResumed());
    upload.on('success', () => resolve());
    upload.on('error', event => reject(new Error((event && event.detail && event.detail.message) || 'The upload failed. Try again.')));
  });
  return {
    done,
    abort() {
      upload.abort();
      rejectDone(cancelledError());
    },
  };
}

// Single PUT with progress. Used only if UpChunk cannot be built by this app's webpack 4.
export function startXhrUpload({ endpoint, file, onProgress, XHR = XMLHttpRequest }) {
  const xhr = new XHR();
  const done = new Promise((resolve, reject) => {
    xhr.open('PUT', endpoint);
    xhr.upload.onprogress = event => {
      if (event.lengthComputable && onProgress) onProgress(Math.round((event.loaded / event.total) * 100));
    };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`The upload failed (${xhr.status}). Try again.`)));
    xhr.onerror = () => reject(new Error('The upload failed. Check your connection and try again.'));
    xhr.onabort = () => reject(cancelledError());
    xhr.send(file);
  });
  return { done, abort: () => xhr.abort() };
}
